import { useState } from "react";
import CustomDialog from "../../../../../components/Dialog/DiaCompMedium";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ClockText from "./ClockText";


export default function DiaClockInfo() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
  
    <Tooltip title="Info" placement="right">
        <IconButton onClick={handleOpen} size="small">
            <InfoOutlinedIcon />
        </IconButton>   
    </Tooltip>
   
    <CustomDialog open={open} onClose={handleClose}

          title="Clocks predicting biological age"
         
          content = {<ClockText />}

        />
        
</>
)}